// Common styles for form pages
export const PAGE_STYLES = {
    container: {
        backgroundRepeat: 'no-repeat',
        backgroundColor: (t) => (t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900]),
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        width: '100%',
        height: '100vh',
    },
    contentBox: (isMediumScreen) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2,
        width: isMediumScreen ? '70%' : '50%',
        height: '50vh',
        m: '0 auto',
        borderRadius: 5,
        bgcolor: '#ffffff',
        opacity: 0.85,
        p: isMediumScreen ? 5 : 2,
    }),
    title: {
        fontSize: '2rem',
        fontWeight: 'bold',
        color: '#003a52',
        mb: 3,
    },
    description: {
        fontSize: '1.3rem',
    },
    logo: {
        width: 130,
        height: 130,
        p: 3,
        opacity: 1,
    },
    button: (isMediumScreen) => ({
        width: isMediumScreen ? '30%' : '20%',
        height: '5vh',
        bgcolor: '#00647e',
        color: 'white',
        fontWeight: 'bold',
        borderRadius: 5,
        mt: 7,
        ':hover': {
            backgroundColor: '#003a52',
        },
    }),
};

// Responsive breakpoints
export const BREAKPOINTS = {
    MEDIUM: 1493,
    SMALL: 1130,
    MOBILE: 1024,
};
